import React, { forwardRef } from "react";

const InputComponent = forwardRef(({
  label,
  name,
  id,
  value,
  onChange,
  type = "text",
  placeholder = "",
  options = [],
  margin,
  fullWidth,
  SelectProps,
  disabled,
  className,
  error = "",
  inputClassName = "",
}, ref = null) => {
  return (
    <div className={`relative ${fullWidth ? "w-full" : ""} ${className}`}>
      <label
        htmlFor={id}
        className="mb-1 text-gray-800 bg-white font-semibold text-[14px] block text-left"
      >
        {label}
      </label>

      {type === "select" ? (
        <select
          id={id}
          value={value}
          onChange={onChange}
          className={` min-h-[45px] w-full px-5 outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 ${inputClassName}`}
          {...SelectProps}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          disabled={disabled}
          ref={ref}
          name={name}
          id={id}
          value={value}
          type={type}
          onChange={onChange}
          placeholder={placeholder}
          className={`min-h-[45px] w-full px-5 outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 ${inputClassName}`}
        />
      )}

      <div className=" text-red-500 text-sm text-left">{error}</div>
    </div>
  );
});

export default InputComponent;
